<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    <div class="mb-4">
      <app-admin-card-with-title
        [cardTitle]="t('app.common.paymentSettings')" [removeTopMargin]="true">
        <div class="row">
          <div class="col-12 col-xl-8">
            <!-- Mandatory payment for completing the registration-->
            <div class="form-check form-switch mb-4">
              <input class="form-check-input" type="checkbox" id="mandatoryPayment" formControlName="mandatoryPayment">
              <label class="form-check-label fw-bold text-uppercase" for="mandatoryPayment">
                {{ t("event.payment.settings.mandatory.payment") }}
                @if (inputForm.controls['mandatoryPayment'].errors?.['required']) {
                  <span>*</span>
                }
              </label>
              @if (inputForm.controls['mandatoryPayment'].touched) {
                @for (errorMessage of inputForm.controls['mandatoryPayment']!.errors | errorMessages:'mandatoryPayment';track errorMessage) {
                  <span class="errorMes pt-1">{{ errorMessage }}</span>
                }
              }
            </div>
            <!-- Payment method-->
            <app-select formControlName="paymentMethod" [items]="paymentMethods"
                        [valueKey]="'id'" [labelKey]="'id'" labelKeyPrefix="event.payment.settings.payment.method."
                        label="event.payment.settings.payment.method"/>
            <!-- Create 2D barcode-->
            <div class="form-check form-switch mb-4 mt-5">
              <input class="form-check-input" type="checkbox" id="create2DBarcode" formControlName="createBarcode">
              <label class="form-check-label fw-bold text-uppercase" for="create2DBarcode">
                {{ t("event.payment.settings.create.barcode") }}
                @if (inputForm.controls['createBarcode'].errors?.['required']) {
                  <span>*</span>
                }
              </label>
              @if (inputForm.controls['createBarcode'].touched) {
                @for (errorMessage of inputForm.controls['createBarcode']!.errors | errorMessages:'createBarcode';track errorMessage) {
                  <span class="errorMes pt-1">{{ errorMessage }} </span>
                }
              }
            </div>
            <!-- Payment type-->
            <div class="mb-3">
              <app-multiselect-dropdown [options]="paymentTypesOptions"
                                        formControlName="paymentType"
                                        [dropdownLabel]="t('event.payment.settings.payment.type')"/>
            </div>
            <div class="row">
              <div class="col-4 reduce-column-right-spacing">
                <!-- Issuing an invoice-->
                <app-select formControlName="issuingInvoice" [items]="[true, false]"
                            [translatedLabels]="[t('event.payment.settings.issuing.invoice') +
                      ' - ' + t('app.common.yes'), t('event.payment.settings.issuing.invoice') + ' - ' +
          t('app.common.no')]" label="event.payment.settings.issuing.invoice"/>
              </div>
              <div class="col-8 reduce-column-left-spacing">
                <!-- Deadline in hours-->
                <app-input type="number" formControlName="validHours"
                           label="event.payment.settings.deadline"/>
              </div>
            </div>
          </div>
        </div>
      </app-admin-card-with-title>
    </div>
    <div class="admin-card">
      <div class="row">
        <div class="col-12 col-xl-8">
          <!-- Payment reminder-->
          <div class="form-check form-switch mb-4">
            <input class="form-check-input" type="checkbox" id="paymentReminder" formControlName="paymentReminder">
            <label class="form-check-label fw-bold text-uppercase" for="paymentReminder">
              {{ t("event.payment.settings.reminder") }}
              @if (inputForm.controls['paymentReminder'].errors?.['required']) {
                <span>*</span>
              }
            </label>
            @if (inputForm.controls['paymentReminder'].touched) {
              @for (errorMessage of inputForm.controls['paymentReminder']!.errors | errorMessages:'paymentReminder';track errorMessage) {
                <span class="errorMes pt-1">{{ errorMessage }} </span>
              }
            }
          </div>
          <div>
            <div class="row">
              <div class="col-md-6 reduce-column-right-spacing pb-3">
                <app-input type="number" formControlName="days" label="app.common.days" [min]="0"
                           [max]="30"/>
              </div>
              <div class="col-md-6 reduce-column-left-spacing pb-3">
                <app-input type="number" formControlName="hours" label="app.common.hours" [min]="0"
                           [max]="23"/>
              </div>
            </div>
            <div class="pb-3">
              <app-textarea id="messageForUnpaidRegistration" formControlName="reminderMessage" rows="3"
                            label="event.payment.settings.reminder.message"/>
            </div>

            <!--                  Payment reminder delivery method-->
            <app-multiselect-dropdown [options]="paymentReminderMethodsOptions"
                                      formControlName="reminderMethod"
                                      [dropdownLabel]="t('event.payment.settings.reminder.delivery.method')"
                                      [isDropdownListFullWidth]="true"/>
          </div>
        </div>
      </div>
    </div>
    <app-action-buttons-row (onSave)="onSave()"/>
  </form>
</ng-container>
